<template>
  <div class="q-pa-md">
    <!-- Data Stores Hack, need to be loaded first -->
    <ChargeAccountStore ref="chargeAccountStore" />
    <ReceiptsStore ref="receiptsStore" :selectedTimePeriod="selectedTimePeriod" />
    <MonthlyChargesStore ref="monthlyChargesStore" :selectedTimePeriod="selectedTimePeriod" />
    <!-- ///////////////////////////////////////// -->

    <!-- DEV -->
    <!-- <h1>Charges Page</h1> -->
    <!--  -->

    <ReceiptInterface :selectedTimePeriod="selectedTimePeriod" :storeName="receiptsStore"/>
    <!-- TODO: Add back in when we have a monthly charges table -->
    <MonthlyChargesTable :selectedTimePeriod="selectedTimePeriod" :storeName="monthlyChargesStore"/>
  </div>
  
</template>

<script>
import ChargeAccountStore from '../stores/ChargeAccountStore.vue'
import ReceiptsStore from '../stores/ReceiptsStore.vue'
import MonthlyChargesStore from '../stores/MonthlyChargesStore.vue'
import MonthlyChargesTable from './components/MonthlyChargesTable.vue'
import ReceiptInterface from './components/ReceiptInterface.vue'

export default {
  name: 'ChargesPage',
  data(){
    return {
      // TODO: Add any data fields required for the page
    }
  },
  onMounted(){
    console.log('DEBUG', 'onMounted', this.$options.name);
  },
  components:{
    ReceiptsStore, 
    ReceiptInterface,
    MonthlyChargesStore, 
    MonthlyChargesTable, 
    ChargeAccountStore,
  },
  provide(){
    return {
      page: this,
    }
  },
}
</script>

